module.exports = __webpack_public_path__ + "static/media/rotating-phone.b019bc3c.svg";